import Button, { ButtonProps } from "./Button";
import classes from "../../styles/Buttons.module.css";
import { getClasses } from "../../utils";

type ModalButtonProps = {
  type?: "danger" | "accent" | "pale" | "normal";
  fill?: boolean;
  minWidth?: string;
  minHeight?:string;
};

const ModalButton: React.FC<ModalButtonProps & ButtonProps> = (props) => {
  // if fill is set to true the button will fill its container
  const t = props.type ?? "";
  const className = props.fill ? "modal fill " + t : "modal " + t

  const keys = ["minHeight", "minWidth"] as (keyof ModalButtonProps)[];
  const style = keys.reduce((obj: any, key) => {
    if (props[key]) {
      obj[key] = props[key];
    }
    return obj;
  }, {});

  return (
    <Button {...props} className={getClasses(classes, className)}>
      <div style={style}>{props.children}</div>
    </Button>
  );
};

export default ModalButton;
